<template>
  <div class="component-body">
    <div class="flex">
      <el-date-picker
          v-model="value"
          type="date"
          placeholder="选择日期">
      </el-date-picker>
      <el-time-picker
          class="margin-left-10"
          is-range
          v-model="value1"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          placeholder="选择时间范围">
      </el-time-picker>
    </div>
    <div class="flex margin-top-16">
      <el-date-picker
          v-model="value"
          type="date"
          placeholder="选择日期">
      </el-date-picker>
      <el-time-picker
          disabled
          class="margin-left-10"
          is-range
          v-model="value1"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          placeholder="选择时间范围">
      </el-time-picker>
    </div>
  </div>
</template>

<script>
export default {
  name: 'index',
  data () {
    return {
      value: '',
      value1: [new Date(2016, 9, 10, 8, 40), new Date(2016, 9, 10, 9, 40)]
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/12/DatePicker/index.vue